import { Head } from "@inertiajs/react";

interface PublicMetadata {
  title: string;
  description: string;
  canonical: string;
  image?: string;
  noindex: boolean;
  structuredData: Record<string, unknown> | null;
}

export default function PublicPageHead({ component, metadata }: {
  component: string;
  metadata?: PublicMetadata | null;
}) {
  if (!metadata) return null;

  return (
    <>
      {component.startsWith("salonjobs/") && <Head title={metadata.title}>
        <meta head-key="description" name="description" content={metadata.description} />
        <link head-key="canonical" rel="canonical" href={metadata.canonical} />
        <meta head-key="robots" name="robots" content={metadata.noindex ? "noindex, follow" : "index, follow"} />
        <meta head-key="og:title" property="og:title" content={metadata.title} />
        <meta head-key="og:description" property="og:description" content={metadata.description} />
        <meta head-key="og:url" property="og:url" content={metadata.canonical} />
        <meta head-key="og:type" property="og:type" content="website" />
        <meta head-key="og:site_name" property="og:site_name" content="Hairbook Salonjobs" />
        {metadata.image && <meta head-key="og:image" property="og:image" content={metadata.image} />}
      </Head>}
      {metadata.structuredData && <Head>
        <script head-key="structured-data" type="application/ld+json">
          {JSON.stringify(metadata.structuredData).replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026")}
        </script>
      </Head>}
    </>
  );
}
